import {
  BiometricPromptTrackingPoint,
  ReloginBiometricsTrackingPoint,
  ReloginPasswordTrackingPoint,
} from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const BiometricPromptTrackingSchema: Record<
  BiometricPromptTrackingPoint,
  string
> = {
  [BiometricPromptTrackingPoint.PageView]: '',
  [BiometricPromptTrackingPoint.BackClick]: '',
  [BiometricPromptTrackingPoint.EnableBiometricClick]: '',
  [BiometricPromptTrackingPoint.SetupLaterClick]: '',
  [BiometricPromptTrackingPoint.EnableSuccessImpression]: '',
  [BiometricPromptTrackingPoint.EnableSuccessOkClick]: '',
  [BiometricPromptTrackingPoint.EnableFailTooManyTimesOkClick]: '',
  [BiometricPromptTrackingPoint.EnableFailTooManyTimesImpression]: '',
};

const ReloginBiometricsTrackingSchema: Record<
  ReloginBiometricsTrackingPoint,
  string
> = {
  [ReloginBiometricsTrackingPoint.PageView]: '',
  [ReloginBiometricsTrackingPoint.ReloginBiometricLoginClick]: '',
  [ReloginBiometricsTrackingPoint.ReloginSignupClick]: '',
  [ReloginBiometricsTrackingPoint.ReloginWithAnotherAccountClick]: '',
  [ReloginBiometricsTrackingPoint.ReloginWithOtherMethodsClick]: '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsSelectionImpression]: '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithPhoneClick]: '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithPasswordClick]:
    '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithQuickLoginClick]:
    '',
  [ReloginBiometricsTrackingPoint.QuickLoginToggleImpression]: '',
  [ReloginBiometricsTrackingPoint.QuickLoginToggleClick]: '',
  [ReloginBiometricsTrackingPoint.QuickLoginTooltipImpression]: '',
  [ReloginBiometricsTrackingPoint.QuickLoginActionSuccess]: '',
};

const ReloginPasswordTrackingSchema: Record<
  ReloginPasswordTrackingPoint,
  string
> = {
  [ReloginPasswordTrackingPoint.PageView]:
    'f5c6bc2e-9c1c-4856-9437-9f31d52ff136',
  [ReloginPasswordTrackingPoint.ReloginSignupClick]:
    '39afbc58-d1ba-4e05-90c2-706c4dfb2c84',
  [ReloginPasswordTrackingPoint.ReloginWithAnotherAccountClick]:
    '068d696e-bf28-4f18-900c-a85cec0d99d2',
  [ReloginPasswordTrackingPoint.ReloginWithOtherMethodsClick]:
    '6a3899ed-cac7-4fa8-9cbb-d5b90143ade7',
  [ReloginPasswordTrackingPoint.ReloginWithPasswordLoginClick]:
    '941ae0f8-d506-4ba7-88e8-8215e45af003',
  [ReloginPasswordTrackingPoint.ForgotPasswordClick]:
    'c20e68b4-ee42-4d96-ad79-26f7fd685269',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsSelectionImpression]:
    '6e15de5d-5514-4722-88a1-e7dcb533fde0',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithBiometricsClick]:
    'b5f9e8af-b63c-4c7c-ba8f-66c14237a07f',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithPhoneClick]:
    '5f5c2a0c-d114-4a28-ba90-254af3fd0170',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithQuickLoginClick]:
    '36c1d2e8-67c5-420f-a524-b04e3a79905a',
  [ReloginPasswordTrackingPoint.ReloginHelpClick]:
    '696fe1dc-c8db-4d0b-a4c6-aab09c111fa5',
  [ReloginPasswordTrackingPoint.QuickLoginToggleImpression]:
    '6be4aebf-55fa-4de4-b698-dbba14bd71b8',
  [ReloginPasswordTrackingPoint.QuickLoginToggleClick]:
    '2c35d125-2301-4608-b63b-fa6bbebbad0f',
  [ReloginPasswordTrackingPoint.QuickLoginTooltipImpression]:
    'b81710f7-b073-4c1d-a0dd-655291aa85ef',
  [ReloginPasswordTrackingPoint.QuickLoginActionSuccess]:
    '9563c543-4d13-4b10-9b0a-c47b373fbee9',
};
export const getBiometricPromptPageTypeAndSchema = (
  trackingPoint: BiometricPromptTrackingPoint
) => {
  return {
    page_type: PageType.BiometricPromptPage,
    schema: BiometricPromptTrackingSchema[trackingPoint],
  };
};

export const getReloginBiometricsPageTypeAndSchema = (
  trackingPoint: ReloginBiometricsTrackingPoint
) => {
  return {
    page_type: PageType.ReloginBiometricsPage,
    schema: ReloginBiometricsTrackingSchema[trackingPoint],
  };
};

export const getReloginPasswordPageTypeAndSchema = (
  trackingPoint: ReloginPasswordTrackingPoint
) => {
  return {
    page_type: PageType.ReloginPasswordPage,
    schema: ReloginPasswordTrackingSchema[trackingPoint],
  };
};
